const excludedFieldTypes = ['textblock', 'link'];

const getFlattenProp = propName => (flattenValue, object) => [...flattenValue, ...object[propName]];

//get all field ids from schema into a flat array
export const getFieldsIdsByPage = form => {
  if (form.pages) {
    const arrayOfGroupArraysByPage = form.pages.reduce((acc, page) => {
      const groupsByPage = [page].reduce(getFlattenProp('groups'), []);

      acc.push(groupsByPage);
      return acc;
    }, []);

    const arrayOfFieldsArraysByPage = arrayOfGroupArraysByPage.reduce((acc, page) => {
      const fieldsByPage = page.reduce(getFlattenProp('fields'), []);

      acc.push(fieldsByPage);
      return acc;
    }, []);

    const arrayOfOnlyInputFieldsObjectsByPage = arrayOfFieldsArraysByPage.reduce((acc, fields) => {
      const result = [];

      fields.forEach(field => {
        if (!excludedFieldTypes.includes(field.type)) {
          const allFields = ['subfields', 'flex'].includes(field.type) ? field.fields : [field];
          result.push(...allFields);
        }
      });

      acc.push(result);

      return acc;
    }, []);

    return arrayOfOnlyInputFieldsObjectsByPage.reduce((acc, fields) => {
      const result = [];

      fields.forEach(field => {
        result.push(field.id);
      });

      acc.push(result);
      return acc;
    }, []);
  }

  return [];
};
